import React from "react";
import { IoSend } from "react-icons/io5";
import { useDispatch } from "react-redux";
import {
  createAllMediaInformationAction,
  udpateAllMediaInformationAction,
} from "../../Actions/MediaInformationAction/MedicaInformationAction";

const MediaAllInfoSend = ({
  loadingAllInfo,
  allInfo,
  mediaAllInfo,
  visitId,
  branchId,
}) => {
  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    e.preventDefault();
    if (allInfo?.id || mediaAllInfo?.id) {
      dispatch(
        udpateAllMediaInformationAction(
          allInfo?.id || mediaAllInfo?.id,
          visitId,
          branchId
        )
      );
      return;
    } else {
      dispatch(createAllMediaInformationAction(visitId, branchId));
      return;
    }
  };
  return (
    // <form action="" onSubmit={handleSubmit}>
      <button
      onClick={handleSubmit}
        disabled={loadingAllInfo}
        className={`btn-blue ${
          loadingAllInfo && "opacity-50"
        } gap-16 group mt-2`}
        type="submit"
      >
        Send
        <p className=" -translate-x-2 group-hover:-translate-x-0  duration-500">
          <IoSend />
        </p>
      </button>
    // </form>
  );
};

export default MediaAllInfoSend;
